<template>
  <GcBaseLayout
    :title="leftGridConfig.title"
    :isXSmall="isXSmall"
    :isLarge="isLarge"
    :baseView="baseView"
    :key="pageKey"
    :backButtonEnable="true"
    :backButtonFunction="backButtonFunction"
    :formsConfig="formsConfig"
  >
    <template #headerContent>
      <GcHeaderContentDynamic
        :title="'Sales Order'"
        :createModeIsEditMode="true"
        :baseView="baseView"
        :primaryLabel="'Grower Pool Splits'"
        :secondaryLabel="undefined"
      />
    </template>
    <div class="split-view-template css-v2 split-view grower-pool-splits">
      <GcSplitView
        :showLeftContainer="true"
        :showRightContainer="showRightPanel"
      >
        <template #leftContent>
          <div class="css-v2 split-view-list">
            <GcDataGrid
              :grouping="true"
              :export="true"
              :summary="true"
              :dataSourceConfig="leftGridConfig.gridData.gridOptions.dataSource"
              :columns="leftGridConfig.gridData.columns"
              :gridToolbar="leftGridConfig.gridData.toolbar"
              :padColumn="true"
              :id="'grower-pool-splits-left-grid'"
              :rowClick="onLeftRowClick"
              :exportFileName="leftGridConfig.exportFileName"
              :heightPadding="20"
              :paging="false"
              ref="leftGrid"
            />
          </div>
        </template>

        <template #rightContent>
          <div class="right-panel-container" v-if="showRightPanel">
            <GcFormHeaderToolbar
              :toolbarOptions="rightToolbarOptions"
              :dataModel="toolbarRecord"
              :baseView="baseView"
              :backRoute="leftGridConfig.pageRoute"
              :itemSaveCallBack="onSaveClicked"
            />

            <div class="selected-record-info">
              <GcForm
                :formOptions="{ gcLabelLocation: 'left' }"
                :formItems="identityFormItems"
                :isNormal="true"
                :data-model="selectedRecord"
                :formMode="baseView.mode"
                :formLocation="'normal'"
                :formHeight="baseView.mode === 'create' ? 80 : undefined"
                :formContentReady="formContentReady"
              />
            </div>

            <div class="view-card responsive-paddings split-view-right-grid">
              <DxDataGrid
                :data-source="splitRows"
                key-expr="RowKey"
                :show-borders="false"
                :repaint-changes-only="true"
                :column-auto-width="true"
                :no-data-text="
                  isEditing
                    ? 'No Grower rows yet - click Add Grower above.'
                    : 'No split recorded for this docket yet.'
                "
                @init-new-row="onInitNewRow"
                :columnChooser="{
                  enabled: false,
                }"
                @toolbar-preparing="onGridToolbarPreparing"
                :height="getHeight"
                @row-removed="onRowRemoved"
                @content-ready="onGridContentReady"
                :ref="'rightGrid'"
                :columns="getEditableColumns"
                @editor-preparing="onEditorPreparing"
              >
                <DxLoadPanel :show-indicator="false" :enabled="false" />
                <DxPaging :page-size="50" :enabled="false" />
                <DxPager :visible="false" />
                <DxEditing
                  mode="cell"
                  :allow-updating="isEditing"
                  :allow-adding="isEditing"
                  :allow-deleting="true"
                  :use-icons="true"
                  :select-text-on-edit-start="true"
                />

                <template #growerCellTemplate="{ data }">
                  <span>{{ growerDisplayText(data.data.GrowerCode) }}</span>
                </template>
                <!-- <DxColumn
                  data-field="GrowerCode"
                  caption="Grower"
                  :min-width="220"
                  cell-template="growerCellTemplate"
                  edit-cell-template="growerEditCellTemplate"
                  :validation-rules="growerValidationRules"
                />
                <DxColumn
                  data-field="SplitPcnt"
                  caption="Split %"
                  data-type="number"
                  :format="'#,##0.0000'"
                  alignment="right"
                  :width="ColumnWidth.Percentage.width"
                  :validation-rules="splitPcntValidationRules"
                  :editor-options="{
                    format: '#,##0.0000',
                    max: 100,
                    min: 0.0001,
                  }"
                />
                <DxColumn
                  data-field=""
                  caption=""
                  type="buttons"
                  alignment="right"
                  :max-width="50"
                  :width="50"
                  :buttons="['delete']"
                  :visible="baseView.mode != 'review'"
                />

                <template #growerCellTemplate="{ data }">
                  <span>{{ growerDisplayText(data.data.GrowerCode) }}</span>
                </template>
                <template #growerEditCellTemplate="{ data }">
                  <DxSelectBox
                    :data-source="growerOptions"
                    value-expr="GrowerCode"
                    :display-expr="growerDisplayExpr"
                    :search-enabled="true"
                    :search-expr="['GrowerCode', 'GrowerName']"
                    :show-clear-button="true"
                    :value="data.value"
                    @value-changed="
                      (e) => {
                        onGrowerChanged(e, data);
                      }
                    "
                    @key-down="onGrowerKeyDown($event, data)"
                  />
                </template> -->

                <DxSummary>
                  <DxTotalItem
                    name="SplitPcnt"
                    column="SplitPcnt"
                    summary-type="sum"
                    value-format="##,###,###,###,##0.0000;(##,###,###,###,##0.0000)"
                    display-format="Total: {0} %"
                  />
                </DxSummary>
              </DxDataGrid>

              <!-- §6 footer: Row Count + running Total, good/bad at exactly 100.
                   No SplitViewGridTemplate footer-slot constraint here (this
                   panel is hand-built, not the shared template) - full custom
                   footer per the prototype, not a native grid summary row. -->
              <!-- <div class="split-grid-footer">
                <span>Row Count: {{ splitRows.length }}</span>
                <span>
                  Total Split %
                  <span
                    class="total-value"
                    :class="totalIsValid ? 'good' : 'bad'"
                    >{{ totalDisplay }}</span
                  >
                </span>
              </div> -->
            </div>
          </div>
        </template>
      </GcSplitView>
    </div>
  </GcBaseLayout>
</template>

<script>
/*
Description
    grower-pool-splits.vue - Settings > Intake > Grower Pool Splits (Project 2116,
    Almondco Intake Masters Migration). List + filter panel (#75760) and the
    Review/Edit detail panel with running Total (#75766).

    Rebuilt 2026-08-26 per developer direction to stop routing this screen
    through SplitViewGridTemplate. The layout shell (GcBaseLayout, GcSplitView)
    and the LEFT list (GcDataGrid, unchanged - still the right component for a
    read-only list) are now wired directly, bypassing the template's own
    List/Detail orchestration (rightPanelBaseView, dataSourceBuilder,
    switchToEditMode, etc.) entirely. The RIGHT panel is GcFormHeaderToolbar
    (used exactly as SplitViewGridTemplate itself uses it - same props, no
    change to that component) + GcForm for the read-only identity row + a raw
    devextreme-vue DxDataGrid (NOT GcDataGrid) for the editable Grower/Split %
    grid, since GcDataGrid v1 (the only one registered) hardcodes
    allow-updating + mode="cell" with no allowAdding/allowDeleting support and
    no free footer slot to hang a running-Total bar off.

    This resolves every workaround the SplitViewGridTemplate build needed:
      - Add/Remove Grower rows are now DxEditing's own native allow-adding/
        allow-deleting (a real "+" toolbar button and a delete icon per row),
        not a hand-rolled toolbar button + array-splice + manual grid reload.
      - The running Total footer is genuine custom markup below the grid
        (Row Count + colour-coded Total, matching the prototype exactly),
        not GcDataGrid's native DxSummary - so the SplitPcnt ScreenField
        registry row added for that workaround
        (Graycorp.Gcorp.Database.Financials/Scripts/Post-Deployment/
        ScreenField/SplitPcnt.sql) is no longer load-bearing here (left in
        place - harmless, and still a reasonable general-purpose registry
        entry - but this screen no longer depends on it).
      - The whole-grid Save gate (empty grid / Total <> 100) is still a
        $alert modal, same reasoning as before (a persistent inline banner
        still has nowhere obvious to live without its own layout decision -
        not re-litigated here since the previous instruction on this specific
        point stands). Per-row validation (Grower required, duplicate,
        Split % <= 0) uses DxColumn's own native validation-rules - same
        mechanism as before, still native DevExtreme, no change in approach.
      - baseView.mode (RouteMixin, mixed in directly now rather than via the
        template) drives edit/review state throughout - GcFormHeaderToolbar's
        own edit button pushes /grower-pool-splits/edit/:id itself before
        calling toolbarOptions.editCallBack, and RouteMixin's beforeRouteLeave
        guard now natively prompts "unsaved changes" when navigating away
        mid-edit (a real behavioural improvement - SplitViewGridTemplate's
        own switchToEditMode() never pushed a route, so that guard never
        fired under the old build).
      - AlmondcoGrowerPoolSplitSummary/AlmondcoGrowerSplit are now fetched
        directly (AlmondcoGrowerPoolSplitService) on baseView.id change,
        rather than via SplitViewGridTemplate's dataSourceBuilder contract -
        works identically for a row click and a direct/bookmarked URL.

    Filter panel field resolution (§6/§10) - unchanged from #75760, still
    applies to the LEFT list's columns below:
      - Season       -> screenField "AlmondcoIntakeSeason", filterDataField
                         "SeasonYear", filterDefaultValue "CurrentFiscalYear"
                         (real precedent: almondco-inshell-allocation-list.vue).
      - Depot Docket -> screenField "DepotDocket" (existing global row is
                         Integer/no dataSource - a different, numeric Depot
                         Docket concept from another module), overridden to
                         String, sourced from AlmondcoGrowerPoolSplitSummary.
      - Grower Pool  -> screenField "Grower" (existing global row sources
                         unfiltered api/AlmondcoGrower), overridden to
                         GrowerPoolCode/GrowerPoolName.

    #75767 (Add New Depot Docket picker): addNewGrowerPoolSplit() navigates to
    /grower-pool-splits/create, rendering this same screen with baseView.mode
    "create". showRightPanel and isEditing both had to learn about "create"
    (the create route has no :id, and the grid must be as editable as a real
    Edit session per §6 - no separate Review step). identityFormItems branches
    on baseView.mode === "create" && !selectedRecord.DepotDocket to show a
    single dxSelectBox picker (AlmondcoGrowerPoolSplitSummary, $filter=
    GrowerCount eq 0 - mirrors intake-variety-size.vue's own NumberOfTotalSizes
    eq 0 picker) instead of the read-only identity fields; picking a docket
    (onDocketPicked) sets selectedRecord, which reactively falls through to
    those same read-only fields ("locks read-only" per the AC, for free) and
    starts the grid empty.

History
    25Aug2026 (SD)
        - #75760: UI - Grower Pool Splits List and filter panel
    26Aug2026 (SD)
        - #75766: UI - Grower Pool Split detail panel (Review/Edit grid, running
          Total)
        - Rebuilt off GcBaseLayout/GcSplitView/GcFormHeaderToolbar + a raw
          DxDataGrid directly, per developer direction - see header note above.
        - #75767: UI - Add New Depot Docket picker (unsplit Pool dockets)
        - #75930: API : New Endpoint - 'api/AlmondcoGrowerPoolSearch'. The "Grower
          Pool" filter's dataSourceConfig was wrongly wired to
          AlmondcoGrowerRecipientSearch (individual/syndicate growers, not Pools) -
          rewired to this new distinct Grower Pool lookup, which also fixes the
          duplicate-option bug any per-docket/per-recipient-grower source would
          have had regardless.

(c) Copyright Graycorp Pty Ltd (ABN 12 082 807 761). All Rights Reserved.
*/
import { FeatureStorage } from "@/_services/storage";
import RouteMixin from "@/_mixins/route.mixin";
import FormMixin from "@/_mixins/form.mixin";
import ColumnWidth from "../../../_helpers/data-grid/ColumnWidth";
import { store } from "@/_store";
import { AlmondcoGrowerPoolSplitService } from "@/_services/api/settings/purchasing/almondco-grower-pool-split.service";
import { DxDataGrid, DxSummary, DxTotalItem } from "devextreme-vue/data-grid";

import { backwardTabbing, forwardTabbing } from "../../../_helpers/ui/keyboard";

export default {
  mixins: [RouteMixin, FormMixin],
  components: { DxDataGrid, DxSummary, DxTotalItem },
  data() {
    return {
      ColumnWidth,

      // The selected docket's identity fields (Season/DepotDocket/
      // GrowerPoolCode/GrowerPoolName), from AlmondcoGrowerPoolSplitSummary -
      // read-only, drives the identity row and the Save payload.
      selectedRecord: {},
      toolbarRecord: {},

      // Local, mutable array bound directly to DxDataGrid's data-source -
      // Add/Remove/edit all operate on this array in place via DxEditing's
      // native allow-adding/allow-deleting/allow-updating.
      splitRows: [],
      nextRowKey: 1,

      // AlmondcoGrowerRecipientSearch results, loaded once - the Grower
      // picker's option list is docket-independent (§5).
      growerOptions: [],

      leftGridConfig: {
        title: "Grower Pool Splits",
        pageRoute: "/grower-pool-splits",
        exportFileName: "Grower Pool Splits List",

        gridData: {
          gridOptions: {
            dataSource: {
              endpoint: "AlmondcoGrowerPoolSplitSummary",
              serverPaging: true,
              allowGrouping: false,
            },
          },

          toolbar: {
            search: true,
            columnChooser: true,
            export: false,
            openFilter: true,
            expand: false,
            customButtons: [
              {
                icon: "plus",
                label: "Add New",
                clickAction: () => {
                  this.addNewGrowerPoolSplit();
                },
                buttonLocation: "left",
                visible: FeatureStorage.checkPermission(
                  "AlmondcoGrowerPoolSplits",
                  "create",
                ),
              },
            ],
          },

          columns: [
            {
              // §6: Season filter default = current fiscal year. Same
              // screenField/filterDataField/filterDefaultValue recipe already
              // live on almondco-inshell-allocation-list.vue.
              screenField: "AlmondcoIntakeSeason",
              gridDataField: "SeasonYearAsString",
              filterDataField: "SeasonYear",
              label: "Season",
              filterLabel: "Season",
              filterIndex: 0,
              filterDefaultValue: "CurrentFiscalYear",
              allowHiding: false,
              width: ColumnWidth.SeasonYear.width + 30,
              minWidth: ColumnWidth.SeasonYear.minWidth + 30,
              valueExpr: "Season",
              displayExpr: "SeasonAsString",
              searchExpr: "SeasonAsString",
              forceWidth: true,
              sortIndex: 0,
              sortOrder: "desc",
            },
            {
              // §8: DepotDocket is VARCHAR(20) - the existing global "DepotDocket"
              // ScreenField is a different, Integer-typed, no-dataSource concept
              // from another module. Overridden to a String tag-box sourced from
              // this feature's own summary view.
              screenField: "DepotDocket",
              gridDataField: "DepotDocket",
              filterDataField: "DepotDocket",
              label: "Depot Docket",
              filterLabel: "Depot Docket",
              filterIndex: 1,
              type: "String",
              valueExpr: "DepotDocket",
              displayExpr: "DepotDocket",
              dataSourceConfig: {
                endpoint: "api/AlmondcoGrowerPoolSplitSummary",
                sort: { selector: "DepotDocket", asc: true },
              },
              allowHiding: false,
              width: ColumnWidth.Code.width + 40,
              minWidth: ColumnWidth.Code.minWidth + 40,
              forceWidth: true,
            },
            {
              // Field mapping (user-stories.md Story 2): GrowerPoolCode /
              // GrowerPoolName -> "Grower Pool", description primary / code
              // secondary per common.md. Reuses the existing global "Grower"
              // ScreenField, overridden to this view's Grower Pool columns.
              //
              // Filter option list sourced from AlmondcoGrowerPoolSearch (#75930),
              // NOT AlmondcoGrowerPoolSplitSummary/
              // AlmondcoGrowerRecipientSearch - both of those are graded coarser
              // than one row per Pool (per-docket / per-recipient-grower), so a
              // Pool spanning more than one docket showed its name duplicated in
              // the dropdown. AlmondcoGrowerPoolSearch is one row per Pool-type
              // SUPP_CODE (its own clustered PK), inherently distinct.
              screenField: "Grower",
              gridDataField: "GrowerPoolName",
              filterDataField: "GrowerPoolCode",
              label: "Grower Pool",
              filterLabel: "Grower Pool",
              filterIndex: 2,
              valueExpr: "GrowerPoolCode",
              displayExpr: "GrowerPoolName",
              dataSourceConfig: {
                endpoint: "api/AlmondcoGrowerPoolSearch",
                sort: { selector: "GrowerPoolName", asc: true },
                select: ["GrowerPoolCode", "GrowerPoolName"],
              },
              editorTemplate: {
                primary: [{ dataField: "GrowerPoolName" }],
                secondary: [{ dataField: "GrowerPoolCode" }],
              },
              cellTemplate: "GcRecordCell",
              cellTemplateRecord: {
                primary: [{ dataField: "GrowerPoolName" }],
                secondary: [{ dataField: "GrowerPoolCode" }],
              },
              exportFields: [
                { dataField: "GrowerPoolCode", label: "Grower Pool Code" },
                { dataField: "GrowerPoolName", label: "Grower Pool Name" },
              ],
              allowHiding: false,
              width: ColumnWidth.CompanyName.width,
              minWidth: ColumnWidth.CompanyName.minWidth,
            },
            {
              // BR: GrowerCount = 0 is a meaningful "not yet apportioned" signal,
              // not hidden (user-stories.md Story 2). Not a filter field.
              screenField: "GrowerCount",
              dataField: "GrowerCount",
              label: "Grower Count",
              alignment: "center",
              allowHiding: false,
              width: ColumnWidth.ItemCount.width,
              minWidth: ColumnWidth.ItemCount.minWidth,
              forceWidth: true,
            },
            {
              screenField: "DocketTotalWeight",
              dataField: "TotalWeight",
              label: "Docket Total Weight",
              alignment: "right",
              allowHiding: false,
              format: "###,##0.00",
              width: ColumnWidth.Weight.width + 20,
              minWidth: ColumnWidth.Weight.minWidth,
              forceWidth: true,
            },
          ],
        },
      },
      rightGridHeight: "auto",
      headerFormInstance: undefined,
    };
  },

  // Vue Router 3 only advances navigation (and mounts this component) once
  // `next()` is called - so awaiting the dispatch before calling it blocks
  // the route transition until CurrentFiscalYear is actually resolved.
  async beforeRouteEnter(to, from, next) {
    await store.dispatch("defaultDateSettings/setCurrentFiscalData");
    next();
  },

  computed: {
    getHeight() {
      return this.rightGridHeight;
    },
    showRightPanel() {
      return (
        (this.baseView.id !== null &&
          this.baseView.id !== undefined &&
          this.baseView.id !== "") ||
        // #75767: the create route has no :id (a docket isn't picked yet),
        // so the id-based check above alone would hide the panel entirely.
        this.baseView.mode === "create"
      );
    },
    isEditing() {
      // #75767: "+ ADD NEW" opens directly in Edit mode (§6, no Review step) -
      // the create picker's grid must be as editable as a real Edit session.
      return this.baseView.mode === "edit" || this.baseView.mode === "create";
    },

    // §6: pencil/floppy/close - no Active/Inactive toggle. Visibility between
    // edit and save is GcFormHeaderToolbar's own baseView.mode branching, not
    // ours to manage here.
    rightToolbarOptions() {
      return {
        closeSplit: true,
        edit: FeatureStorage.checkPermission(
          "AlmondcoGrowerPoolSplits",
          "create",
        ),
        // Hardcoded to 'update' - the create-vs-update ternary from §6's
        // corrected PO ruling needs a real create-mode entry point, which is
        // #75767's own scope.
        save: FeatureStorage.checkPermission(
          "AlmondcoGrowerPoolSplits",
          "create",
        ),
        audit: this.baseView.mode === "review",
      };
    },

    // Identity row (§6): Season / Depot Docket / Grower Pool, read-only,
    // resolved from the selected docket - never separately re-entered.
    // #75767: before a docket is picked in create mode, this is instead a
    // single dxSelectBox picker (GrowerCount eq 0 - unsplit Pool dockets,
    // matching intake-variety-size.vue's own NumberOfTotalSizes eq 0
    // create-mode picker exactly). Once picked, selectedRecord.DepotDocket
    // is set (onDocketPicked) and this reactively falls through to the same
    // read-only fields the review/edit flow already uses below - "locks
    // Season/Depot Docket/Grower Pool read-only" per the AC, for free.
    identityFormItems() {
      if (this.baseView.mode === "create") {
        return [
          {
            itemType: "group",
            caption: "",
            colCount: 1,
            items: [
              {
                dataField: "DepotDocket",
                label: { text: "Depot Docket" },
                editorType: "dxSelectBox",
                editorOptions: {
                  dataSource: AlmondcoGrowerPoolSplitService.dataSourceConfig(
                    "api/AlmondcoGrowerPoolSplitSummary",
                    {
                      sort: [
                        { selector: "SeasonYear", desc: true },
                        { selector: "DepotDocket", asc: true },
                      ],
                      filter: [["GrowerCount", "=", 0]],
                    },
                  ),
                  valueExpr: "DepotDocket",
                  displayExpr: (item) => {
                    return item
                      ? `${item.SeasonYear} · ${item.DepotDocket} · ${item.GrowerPoolCode} - ${item.GrowerPoolName}`
                      : "";
                  },
                  searchEnabled: true,
                  showClearButton: true,
                  onValueChanged: this.onDocketPicked,
                  onKeyDown: (e) => {
                    this.onDocketPickedKeyDown(e);
                  },
                  onFocusIn: (e) => {
                    e.event.target.select();
                  },
                  // onSelectionChanged: this.onDocketPicked,
                },
                validationRules: [
                  { type: "required", message: "Depot Docket is required" },
                ],
              },
            ],
          },
        ];
      } else {
        return [
          {
            itemType: "group",
            caption: "",
            colCount: 1,
            items: [
              {
                dataField: "SeasonYear",
                label: { text: "Season" },
                editorType: "dxTextBox",
                editorOptions: { readOnly: true },
              },
              {
                dataField: "DepotDocket",
                label: { text: "Depot Docket" },
                editorType: "dxTextBox",
                editorOptions: { readOnly: true },
              },
              {
                dataField: "GrowerPoolName",
                label: { text: "Grower Pool" },
                editorType: "dxTextBox",
                editorOptions: { readOnly: true },
              },
            ],
          },
        ];
      }
    },

    // BR-05, native inline validation (Apply-equivalent).
    growerValidationRules() {
      const vm = this;
      return [
        { type: "required", message: "Every row requires a Grower." },
        {
          type: "custom",
          message: "This Grower has already been entered.",
          validationCallback: (e) => {
            const code = (e.value || "").trim().toLowerCase();
            if (!code) return true;
            return (
              vm.splitRows.filter(
                (r) => (r.GrowerCode || "").trim().toLowerCase() === code,
              ).length <= 1
            );
          },
        },
      ];
    },
    splitPcntValidationRules() {
      return [
        {
          type: "range",
          min: 0.0001,
          message: "Split % must be greater than 0.",
        },
      ];
    },

    // §6 footer.
    totalSplitPcnt() {
      return this.splitRows.reduce(
        (sum, r) => sum + (parseFloat(r.SplitPcnt) || 0),
        0,
      );
    },
    totalDisplay() {
      return this.totalSplitPcnt.toFixed(4) + "%";
    },
    // FLAG-05: strict equality to 100, matching the server - no rounding
    // tolerance. Epsilon here only absorbs JS floating-point noise.
    totalIsValid() {
      return Math.abs(this.totalSplitPcnt - 100) < 0.00001;
    },

    getEditableColumns() {
      return [
        {
          dataField: "GrowerCode",
          caption: "Grower",
          minWidth: 220,
          editorType: "dxSelectBox",
          cssClass:
            this.baseView.mode != "review"
              ? "edit-cell-textbox-field gc-editable-cell-color"
              : undefined,
          editorOptions: {
            dataSource: this.growerOptions,
            valueExpr: "GrowerCode",
            displayExpr: this.growerDisplayExpr,
            searchEnabled: true,
            searchExpr: ["GrowerCode", "GrowerName"],
            showClearButton: true,
            onKeyDown: (e, data) => {
              this.onGrowerKeyDown(e, data);
            },
          },
          cellTemplate: "growerCellTemplate",
          setCellValue: (rowData, value, currentRowData) => {
            if (currentRowData && !currentRowData.GrowerCode) {
              this.addNewRow();
            }

            rowData.GrowerCode = value;

            return rowData;
          },
        },
        {
          dataField: "SplitPcnt",
          caption: "Split %",
          minWidth: 120,
          editorType: "dxNumberBox",
          cssClass:
            this.baseView.mode != "review"
              ? "edit-cell-textbox-field gc-editable-cell-color"
              : undefined,
          format: "##,##0.0000",
          editorOptions: {
            min: 0,
            showSpinButtons: false,
            format: "##,##0.0000",
          },
          setCellValue: (rowData, value) => {
            rowData.SplitPcnt = value;
          },
          // cellTemplate: "splitPcntCellTemplate",
        },
        {
          visible: this.baseView.mode != "review",
          caption: "",
          dataField: "",
          type: "buttons",
          alignment: "right",
          maxWidth: 50,
          width: 50,
          buttons: ["delete"],
        },
      ];
    },
  },

  watch: {
    // Drives both the row-click flow and a direct/bookmarked URL identically -
    // baseView.id is route-derived (RouteMixin), so this fires either way.
    "baseView.id": {
      immediate: true,
      handler(depotDocket) {
        if (depotDocket) {
          this.loadSelectedRecord(depotDocket);
        } else {
          this.selectedRecord = {};
          this.splitRows = [];
        }

        this.setRightGridHeight();
      },
    },
    "baseView.mode": {
      immediate: true,
      handler(mode) {
        this.setRightGridHeight();

        if (mode === "edit") {
          this.$nextTick(() => {
            this.addNewRow();
          });
        }
      },
    },
  },

  created() {
    this.loadGrowerOptions();

    if (this.baseView.mode === "create") {
      this.selectedRecord = {};
      this.addNewRow();

      this.setRightGridHeight();
    }
  },

  methods: {
    addNewRow() {
      this.splitRows.push({
        RowKey: this.nextRowKey++,
        GrowerCode: null,
        SplitPcnt: 0,
      });
    },
    onEditorPreparing(e) {
      if (e.editorOptions && e.editorOptions.onKeyDown) {
        let func = e.editorOptions.onKeyDown;
        if (this.baseView.mode != "review" && e.parentType != "searchPanel")
          e.editorOptions.onKeyDown = (event) => {
            func(event, {
              column: {
                dataField: e.dataField,
              },
              data: e.row.data,
              rowIndex: e.row.rowIndex,
            });
          };
      }
    },
    onDocketPickedKeyDown(e) {
      if (forwardTabbing(e)) {
        if (this.splitRows.length > 0) {
          this.$nextTick(() => {
            const grid = this.$refs.rightGrid;
            if (grid && grid.instance) {
              const dataGrid = grid.instance;
              var cellElement = dataGrid.getCellElement(0, "GrowerCode");
              if (!cellElement) {
                return;
              }
              setTimeout(() => {
                dataGrid.focus(cellElement);
                dataGrid.editCell(0, "GrowerCode");
              }, 10);
            }
          });
        }
      }
    },
    onGrowerKeyDown(e, data) {
      const grid = this.$refs.rightGrid;
      if (grid) {
        // grid.instance.saveEditData();
      }
      if (
        backwardTabbing(e) &&
        data.rowIndex === 0 &&
        data.column.dataField === "GrowerCode"
      ) {
        e.event.preventDefault();

        this.$nextTick(() => {
          if (!this.headerFormInstance) return;
          this.headerFormInstance.getEditor("DepotDocket").focus();
        });
      }
    },
    formContentReady(e) {
      if (this.baseView.mode === "create")
        this.$nextTick(() => {
          if (e) {
            e.component.getEditor("DepotDocket").focus();
            this.headerFormInstance = e.component;
          }
        });
    },
    setRightGridHeight() {
      setTimeout(() => {
        const rightPanel = document.querySelector(
          ".split-container-child.right-container",
        );

        if (!this.showRightPanel || !rightPanel) return;
        const formHeight = document.querySelector(
          ".selected-record-info",
        ).clientHeight;

        this.rightGridHeight =
          rightPanel.clientHeight - formHeight - 10 - 40 - 12;

        this.$nextTick(() => {
          const grid = this.$refs.rightGrid;
          if (grid && grid.instance) {
            grid.instance.updateDimensions();
          }
        });
      }, 200);
    },
    onRowRemoved() {
      this.$nextTick(() => {
        if (this.splitRows.length === 0 && this.baseView.mode === "create") {
          this.addNewRow();
        }
      });
    },
    onGridContentReady(e) {
      if (e) {
        this.$nextTick(() => {
          setTimeout(() => {
            this.setRightGridHeight();
          }, 500);
        });
      }
    },
    onGrowerChanged(e, data) {
      if (e.value && !data.data.GrowerCode) {
        this.addNewRow();
      }
      data.setValue(e.value);
    },
    onLeftRowClick(e) {
      if (!e.data) return;
      this.onRowClicked(e, {
        page: "grower-pool-splits",
        mode: "review",
        idProperty: "DepotDocket",
      });
    },

    addNewGrowerPoolSplit() {
      // §6: "+ ADD NEW" opens the detail panel directly in Edit mode via a
      // GrowerCount eq 0 docket picker - that create-mode picker is #75767's
      // own scope. Wiring the route here only.
      this.$router
        .push({
          path: `${this.leftGridConfig.pageRoute}/create`,
        })
        .then(() => {
          this.$nextTick(() => {
            this.setRightGridHeight();
          });
        });
    },

    backButtonFunction() {
      this.$router.push({ path: "/settings/intake" });
    },

    async loadGrowerOptions() {
      try {
        const res = await AlmondcoGrowerPoolSplitService.getRecipientGrowers();
        this.growerOptions = (res.data && res.data.value) || [];
      } catch (err) {
        this.growerOptions = [];
      }
    },

    growerDisplayExpr(item) {
      return item ? `${item.GrowerCode} - ${item.GrowerName}` : "";
    },
    growerDisplayText(code) {
      const opt = this.growerOptions.find((g) => g.GrowerCode === code);
      return opt ? `${opt.GrowerCode} - ${opt.GrowerName}` : code || "";
    },

    // #75767: fires from the create-mode Depot Docket picker (identityFormItems
    // above) - mirrors intake-variety-size.vue's own handleVarietySelection.
    // Locks the identity row read-only (identityFormItems falls through to the
    // read-only branch once selectedRecord.DepotDocket is set) and starts the
    // grid empty, ready for Add Grower.
    onDocketPicked(e) {
      if (!e || !e.event) return;

      if (!e.value) {
        this.selectedRecord = {};
        this.splitRows = [];
        return;
      }
      this.selectedRecord = e.component.option("selectedItem") || {};
      this.splitRows = [];

      if (this.splitRows.length === 0 && this.baseView.mode === "create") {
        this.addNewRow();
      }
    },

    // §5: AlmondcoGrowerPoolSplitSummary, filtered to the selected docket -
    // resolves the identity row's Season/GrowerPoolName, then loads the
    // docket's existing split rows.
    async loadSelectedRecord(depotDocket) {
      this.showLoading(true);
      try {
        const res = await AlmondcoGrowerPoolSplitService.getPoolSplitSummary(
          depotDocket,
        );
        const rows = (res.data && res.data.value) || [];
        this.selectedRecord = rows[0] || {};
        if (this.selectedRecord.DepotDocket) {
          await this.loadSplitRows(
            this.selectedRecord.DepotDocket,
            this.selectedRecord.SeasonYear,
          );
        } else {
          this.splitRows = [];
        }
      } catch (err) {
        this.selectedRecord = {};
        this.splitRows = [];
      } finally {
        this.showLoading(false);
      }
    },

    // §5: existing split rows for the selected docket, api.AlmondcoGrowerSplit
    // shim (#75754).
    async loadSplitRows(depotDocket, seasonYear) {
      try {
        const res = await AlmondcoGrowerPoolSplitService.getGrowerSplit(
          depotDocket,
          seasonYear,
        );
        const rows = (res.data && res.data.value) || [];

        if (rows && rows.length > 0) {
          this.toolbarRecord = rows[0];
        }
        this.splitRows = rows.map((r) => ({
          RowKey: this.nextRowKey++,
          GrowerCode: r.GrowerCode,
          SplitPcnt: r.SplitPcnt,
        }));
      } catch (err) {
        this.splitRows = [];
      }
    },

    onInitNewRow(e) {
      e.data.RowKey = this.nextRowKey++;
      e.data.SplitPcnt = 0;
    },

    // Relabels DxEditing's native "+" add-row button - cosmetic only, the
    // native add/delete/update behaviour itself needs no wiring here.
    onGridToolbarPreparing(e) {
      e.toolbarOptions.visible = false;
    },

    // §5/§7 (BR-07/BR-08): whole-grid Save gate. Server-authoritative
    // (AlmondcoGrowerSplitBusinessRulesValidator, #75755) re-checks all of
    // this regardless - these are the same messages, client-side, so the user
    // isn't round-tripping to the server for an empty-grid/total check.
    validateBeforeSave() {
      // #75767: create mode, no docket picked yet.
      if (!this.selectedRecord || !this.selectedRecord.DepotDocket) {
        return "Select a Depot Docket before saving.";
      }
      if (this.splitRows.length === 0) {
        return "Grower Split list does not have value(s).";
      }
      if (!this.totalIsValid) {
        return "Grower Total percentage split must equal 100%.";
      }
      return null;
    },

    // itemSaveCallBack(isValid, brokenRules) per GcFormHeaderToolbar's own
    // save button contract - isValid/brokenRules describe the toolbar's own
    // (empty, here) form, not our grid, so both are unused.
    async onSaveClicked() {
      const activeElement = document.activeElement;
      if (activeElement) {
        activeElement.blur();
      }

      await this.$nextTick();
      const blockingMessage = this.validateBeforeSave();
      if (blockingMessage) {
        // Modal, not a toast - honours the AC's "not just a Save-time toast".
        await this.$alert(blockingMessage, "Unable to Save");
        return;
      }

      this.showLoading(true);
      try {
        const payload = {
          DepotDocket: this.selectedRecord.DepotDocket,
          SeasonYear: this.selectedRecord.SeasonYear,
          GrowerSplits: this.splitRows
            .filter((r) => r.GrowerCode)
            .map((r) => ({
              GrowerCode: r.GrowerCode,
              SplitPcnt: r.SplitPcnt,
            })),
        };

        await AlmondcoGrowerPoolSplitService.saveGrowerSplit(payload);

        this.setIgnoreRouteChangeConfirmation();
        await this.$router.push({
          path: `${this.leftGridConfig.pageRoute}/review/${this.selectedRecord.DepotDocket}`,
        });
        // if (this.$refs.leftGrid && this.$refs.leftGrid.getDataSourceInstance) {
        //   this.$refs.leftGrid.getDataSourceInstance().reload();
        // }
      } catch (err) {
        // ApiService interceptor rejects with error.response (the response
        // object), so err.data is the body - matching the sales-order-split
        // popup's own error handling. Save_AlmondcoGrowerSplitController
        // (#75755) returns a BadRequest array of ValidationResult-shaped
        // objects on business-rule failure.
        var data =
          (err && err.data) || (err && err.response && err.response.data);
        var message = "An error occurred while saving the Grower Pool Split.";
        if (Array.isArray(data) && data.length > 0) {
          message = data
            .map(function (e) {
              return e.ErrorMessage || e;
            })
            .join(" ");
        } else if (typeof data === "string" && data.length > 0) {
          message = data;
        }
        await this.$alert(message, "Unable to Save");
      } finally {
        this.showLoading(false);
        this.setRightGridHeight();

        if (this.baseView.id) {
          this.loadSelectedRecord(this.baseView.id);
        }
      }
    },
  },
};
</script>

<style lang="scss">
.grower-pool-splits {
  .split-grid-footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 8px 12px;
    font-size: 12px;
    color: #667085;
    border-top: 1px solid rgba(0, 0, 0, 0.12);
  }

  .total-value {
    font-weight: 600;
    margin-left: 4px;
  }

  /* Matches prototype.html's own good/bad colours for this exact panel, and
   the sales-order-split popup's existing #a3222f error colour - no shared
   success/error CSS variable exists in this codebase to reuse instead. */
  .total-value.good {
    color: #1f7a3d;
  }
  .total-value.bad {
    color: #a3222f;
  }

  .selected-record-info {
    padding: 12px 0px 12px 0px;

    .dx-form {
      background-color: white;
      padding: 12px;
    }
  }

  .split-view-right-grid {
    padding: unset !important;

    .dx-datagrid-header-panel {
      height: 0px !important;
    }
  }
}
</style>
